import { useTranslation } from 'react-i18next';

export default function Features04() {
	const { t } = useTranslation();

	return (
		<section className="relative">
			<div className="relative mx-auto max-w-6xl px-4 sm:px-6">
				{/* Blurred shape */}
				<div
					className="pointer-events-none absolute left-0 top-0 -z-10 -ml-16 -mt-24 opacity-70 blur-2xl"
					aria-hidden="true"
				>
					<svg xmlns="http://www.w3.org/2000/svg" width="434" height="427">
						<defs>
							<linearGradient
								id="bs4-a"
								x1="19.609%"
								x2="50%"
								y1="14.544%"
								y2="100%"
							>
								<stop offset="0%" stopColor="#38B2AC" />
								<stop offset="100%" stopColor="#319795" stopOpacity="0" />
							</linearGradient>
						</defs>
						<path
							fill="url(#bs4-a)"
							fillRule="evenodd"
							d="m0 0 461 369-284 58z"
							transform="matrix(1 0 0 -1 0 427)"
						/>
					</svg>
				</div>

				<div className="pb-12 pt-16 md:pb-20 md:pt-32">
					{/* Section header */}
					<div className="w-full pb-6 md:pb-6">
						<h2 className="h2 bg-gradient-to-r from-slate-200/60 via-slate-200 to-slate-200/60 bg-clip-text pb-4 text-transparent">
							{t('features4.title')}
						</h2>
					</div>

					{/* Rows */}
					<div className="divide-y divide-slate-800">
						{/* Row */}
						<div className="py-8 first-of-type:pt-0 last-of-type:pb-0">
							<div>
								<div className="inline-flex bg-gradient-to-r from-teal-500 to-teal-200 bg-clip-text pb-6 font-medium text-transparent">
									{t('features4.subtitle')}
								</div>
							</div>
							<div className="mb-2 grid gap-8 md:grid-cols-3 md:gap-12">
								{/* Feature 1 */}
								<div>
									<div className="mb-1 flex items-center space-x-2">
										<svg
											className="shrink-0 fill-slate-300"
											xmlns="http://www.w3.org/2000/svg"
											width="16"
											height="16"
										>
											<path d="M13 16c-.153 0-.306-.035-.447-.105l-3.851-1.926c-.231.02-.465.031-.702.031-4.411 0-8-3.14-8-7s3.589-7 8-7 8 3.14 8 7c0 1.723-.707 3.351-2 4.63V15a1.003 1.003 0 0 1-1 1Zm-4.108-4.054c.155 0 .308.036.447.105L12 13.382v-2.187c0-.288.125-.562.341-.752C13.411 9.506 14 8.284 14 7c0-2.757-2.691-5-6-5S2 4.243 2 7s2.691 5 6 5c.266 0 .526-.02.783-.048a1.01 1.01 0 0 1 .109-.006Z" />
										</svg>
										<h4 className="font-medium text-slate-50">
											{t('features4.feature1.title')}
										</h4>
									</div>
									<p className="text-sm text-slate-400">
										{t('features4.feature1.description')}
									</p>
								</div>
								{/* Feature 2 */}
								<div>
									<div className="mb-1 flex items-center space-x-2">
										<svg
											className="shrink-0 fill-slate-300"
											xmlns="http://www.w3.org/2000/svg"
											width="16"
											height="16"
										>
											<path d="M15 9a3.841 3.841 0 0 0-2.661 1.545A2.524 2.524 0 0 0 10 9a1 1 0 1 0 0 2c.361 0 .57.279.89 1.284C10.243 13.08 9.441 14 9 14a1 1 0 0 0 0 2 3.841 3.841 0 0 0 2.661-1.545A2.524 2.524 0 0 0 14 16a1 1 0 0 0 0-2c-.361 0-.571-.279-.89-1.284C13.757 11.92 14.559 11 15 11a1 1 0 0 0 0-2Z" />
											<path d="M10 8a1 1 0 0 0 0-2H7.825c.432-2.421.983-4 2.175-4a1 1 0 0 1 1 1 1 1 0 0 0 2 0 3 3 0 0 0-3-3C7.193 0 6.313 2.9 5.793 6H3a1 1 0 1 0 0 2h2.49c-.506 3.52-1 6-2.49 6a1 1 0 0 1-1-1 1 1 0 0 0-2 0 3 3 0 0 0 3 3c3.367 0 3.964-4.175 4.49-7.858L7.51 8H10Z" />
										</svg>
										<h4 className="font-medium text-slate-50">
											{t('features4.feature2.title')}
										</h4>
									</div>
									<p className="text-sm text-slate-400">
										{t('features4.feature2.description')}
									</p>
								</div>
								{/* Feature 3 */}
								<div>
									<div className="mb-1 flex items-center space-x-2">
										<svg
											className="shrink-0 fill-slate-300"
											xmlns="http://www.w3.org/2000/svg"
											width="16"
											height="16"
										>
											<path d="M7 14c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7ZM7 2C4.243 2 2 4.243 2 7s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5ZM15.707 14.293 13.314 11.9a8.019 8.019 0 0 1-1.414 1.414l2.393 2.393a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414Z" />
										</svg>
										<h4 className="font-medium text-slate-50">
											{t('features4.feature3.title')}
										</h4>
									</div>
									<p className="text-sm text-slate-400">
										{t('features4.feature3.description')}
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
